
export default {
    
    /*-------------------------
        Datas
    ---------------------------*/
    data() {
        return {
            screenWidth: document.documentElement.clientWidth,
            screenHeight: document.documentElement.clientHeight
        };
    },

    /*-------------------------
        Methods
    ---------------------------*/
    methods: {
        _getDimensions() {
            this.screenWidth = document.documentElement.clientWidth;
            this.screenHeight = document.documentElement.clientHeight;
        }
    },

    /*-------------------------
        LifeCycle
    ---------------------------*/
    mounted() {
        window.addEventListener('resize', this._getDimensions);
    },

    unmounted() {
        window.removeEventListener('resize', this._getDimensions);
    },

};
